/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectTimeUpdateCommand } from '../../models/delete-project-time-update-command';
import { DeleteProjectTimeUpdateCommandResult } from '../../models/delete-project-time-update-command-result';

export interface ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Params {
      body?: DeleteProjectTimeUpdateCommand
}

export function apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>;
    })
  );
}

apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain.PATH = '/api/ProjectTimeUpdate/DeleteProjectTimeUpdate';
